<template>
  <div class="page">
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="dataSource"
      :loading="loading"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'stopWS'">
          <WarningFilled
            v-if="record.stopWS"
            style="
               {
                font-size: 22px;
                color: red;
              }
            "
          />
          <span v-else>-</span>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
  import dayjs from 'dayjs'
  import { WarningFilled } from '@ant-design/icons-vue'
  import request from '@/utils/request'
  export default {
    components: { WarningFilled },
    props: {
      currentParams: {
        type: Object,
        default() {
          return {}
        },
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      isOpen: {
        handler(v) {
          if (v) {
            this.getData()
          }
        },
        immediate: true,
      },
    },
    data() {
      return {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: 60,
          },
          {
            title: 'Description',
            dataIndex: 'description',
            minWidth: 100,
          },
          {
            title: 'Job ID',
            dataIndex: 'jobId',
            minWidth: 100,
          },
          {
            title: 'Region Code',
            dataIndex: 'regionCode',
            minWidth: 100,
            sorter: (a, b) =>
              a.regionCode.charCodeAt() - b.regionCode.charCodeAt(),
          },
          {
            title: 'Create Time',
            dataIndex: 'createOn',
            minWidth: 100,
            defaultSortOrder: 'descend',
            customRender({ text }) {
              return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
            },
            sorter: (a, b) => a.createOn.charCodeAt() - b.createOn.charCodeAt(),
          },
          {
            title: 'Resp.By',
            dataIndex: 'responseBy',
            minWidth: 100,
          },
          {
            title: 'Stop WS',
            dataIndex: 'stopWS',
            minWidth: 100,
          },
          {
            title: 'Lost Hr',
            dataIndex: 'lossTime',
            minWidth: 100,
            sorter: (a, b) => a.lossTime - b.lossTime,
            customRender({ text }) {
              return Math.round((text / 3600000) * 100) / 100
            },
          },
          {
            title: 'Resp(Min)',
            dataIndex: 'responseOn',
            minWidth: 100,
            sorter: (a, b) => a.responseOn - b.responseOn,
            customRender({ text, record }) {
              return Math.round(((text - record.createOn) / 60000) * 100) / 100
            },
          },
          {
            title: 'Close(Hr)',
            dataIndex: 'closeOn',
            minWidth: 100,
            sorter: (a, b) => a.closeOn - b.closeOn,
            customRender({ text, record }) {
              return (
                Math.round(((text - record.createOn) / 3600000) * 100) / 100
              )
            },
          },
          {
            title: 'Status',
            dataIndex: 'status',
            minWidth: 100,
            sorter: (a, b) => a.status.charCodeAt() - b.status.charCodeAt(),
          },
        ],
      }
    },
    methods: {
      async refresh() {
        await this.getData()
        return Promise.resolve()
      },
      async getData() {
        this.loading = true
        try {
          const { body } = await request({
            url: '/api/ild/getAndonDetails',
            method: 'post',
            data: this.currentParams,
          })
          this.dataSource = body.filter((m) => m.status !== 'closed')

          this.loading = false
        } catch (e) {
          this.loading = false
        }
        return Promise.resolve()
      },
    },
  }
</script>

<style lang="less" scoped></style>
